/**
 * Calculate Atan2
 */
const atan2 = function (midPointX, midPointY) {
  return Math.atan2(midPointY, midPointX)
}

/**
 * Calculate Two Point Angle to Degrees
 */
const atan2Degree = function (midPointX, midPointY) {
  return 360 - ((((atan2(midPointX, midPointY) * 180 / Math.PI + 180) * 100) >> 0) / 100);
}

export default {
  atan2: atan2,
  atan2Degree: atan2Degree
}
